import React from 'react';
import MaterialIcon from '@/components/MaterialIcon';

/**
 * なぜ今、商業施設にチャットボットが必要なのか - SEO优化新增
 * 说明行业痛点，增强产品必要性
 */
export const WhyChatbotSection: React.FC = () => {
  const challenges = [
    {
      icon: 'group_off',
      title: '案内所の人手不足',
      description:
        '特に週末や繁忙期、案内所には長蛇の列。人材確保も困難な中、AIチャットボットなら24時間365日、人件費ゼロで対応可能です。',
    },
    {
      icon: 'translate',
      title: 'インバウンド対応のコスト',
      description:
        '多言語スタッフの配置は高コスト。GBase SupportのAIコンシェルジュなら、10言語以上に標準対応。翻訳精度も高く、文化的な配慮も可能です。',
    },
    {
      icon: 'map',
      title: 'フロアマップの活用不足',
      description:
        'せっかく設置したフロアマップも、お客様が使いこなせなければ意味がありません。AIとの連携で、「話しかけるだけで目的地を案内」が実現します。',
    },
  ];

  const effects = [
    '案内所への問い合わせ50~70%削減',
    'スタッフは接客業務に集中可能',
    '外国人観光客の満足度向上',
    'フロアマップの利用率3倍',
  ];

  return (
    <section className="w-full px-4 md:px-10 lg:px-40 py-16 bg-gray-50">
      <div className="max-w-[900px] w-full mx-auto">
        <h2 className="text-2xl md:text-3xl font-black text-solution-text mb-4 text-center">
          なぜ今、商業施設にチャットボットが必要なのか？
        </h2>
        <p className="text-solution-text-secondary text-base leading-relaxed mb-10 text-center">
          コロナ禍を経て、商業施設には大きな変化が訪れています。 人手不足の深刻化、インバウンド需要の急回復、
          そしてお客様のデジタル対応への期待値上昇。 AIチャットボットは、これらの課題を一挙に解決する切り札です。
        </p>

        <h3 className="text-xl font-bold text-solution-text mb-6 text-center">商業施設が抱える3つの課題</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {challenges.map((challenge, index) => (
            <div key={index} className="bg-white rounded-xl p-6 border border-gray-100">
              <div className="w-12 h-12 rounded-full bg-solution-orange/10 flex items-center justify-center mb-4">
                <MaterialIcon name={challenge.icon} className="text-solution-orange text-2xl" />
              </div>
              <h4 className="font-bold text-solution-text mb-2">{`${index + 1}. ${challenge.title}`}</h4>
              <p className="text-solution-text-secondary text-sm leading-relaxed">{challenge.description}</p>
            </div>
          ))}
        </div>

        <h3 className="text-xl font-bold text-solution-text mb-6 text-center">導入効果</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {effects.map((effect, index) => (
            <div key={index} className="flex items-center gap-3 bg-white rounded-xl p-4 border border-gray-100">
              <MaterialIcon name="check_circle" className="text-green-500 text-xl shrink-0" />
              <p className="text-solution-text font-medium text-sm">{effect}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChatbotSection;
